import { OutlinedTextFieldProps, TextField } from '@mui/material'
import uniqueId from 'lodash/uniqueId'

export interface LabeledTextFieldType extends Omit<OutlinedTextFieldProps, 'variant'> {
  label: string
  required?: boolean
  dataTestId?: string
  endAdornment?: React.ReactNode
  readOnly?: boolean
  labelTooltip?: React.ReactNode
  slotProps?: OutlinedTextFieldProps['slotProps']
  fieldMetadata?: { isAiPrefilled?: boolean }
}

/** @deprecated Use MUI's `TextField` directly — see the TextField Storybook story in apps/frontend/shared/omui/src/theme2/components/TextField.stories.tsx */
export function LabeledTextField(props: LabeledTextFieldType) {
  const {
    label,
    required,
    endAdornment,
    readOnly,
    labelTooltip,
    slotProps,
    dataTestId,
    fieldMetadata,
    fullWidth = true,
    ...otherProps
  } = props
  const labelId = uniqueId(`${label}-label-`)
  return (
    <TextField
      id={labelId}
      data-is-ai-prefilled={fieldMetadata?.isAiPrefilled}
      label={
        label ? (
          <>
            {label}
            {labelTooltip}
          </>
        ) : undefined
      }
      required={required}
      fullWidth={fullWidth}
      {...otherProps}
      data-testid={dataTestId}
      slotProps={
        slotProps ?? {
          input: { id: labelId, endAdornment, readOnly },
        }
      }
    />
  )
}
